import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat/chat.service';
import { DataService } from 'src/app/services/data/data.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-list-discussion',
  templateUrl: './list-discussion.component.html',
  styleUrls: ['./list-discussion.component.sass']
})
export class ListDiscussionComponent implements OnInit, OnDestroy {
  chats
  currLoc
  dataServiceSub: Subscription;

  constructor(
    private chatService: ChatService, 
    private dataService: DataService, 
    private router: Router,
    private locationStore: LocationStoreService
  ) { 
    this.dataServiceSub = this.locationStore.currLocation$.subscribe(res => {
      if (res.id) this.currLoc = res
    })
  }

  ngOnInit(): void {
    this.dataServiceSub = this.locationStore.currLocation$.subscribe(res => {
      if (res.id) {
        this.currLoc = res
        this.chatService.findAll([{key:'filtered[0][key]', val:'location'}, {key:'filtered[0][val]', val:res.id}]).subscribe(res => {
          
          this.chats = res.data
        })
      }
    })
  }

  ngOnDestroy() {
    this.dataServiceSub.unsubscribe()
  }

  redirectToTable() {
    this.router.navigate(['/projects', this.currLoc.id, 'tables', 'discussions'])
  }
}
